import { invokeApi } from "../../bl_libs/invokeApi";

export const login_api = async (data) => {
  const requestObj = {
    path: `admin_users`,
    method: "POST",
    headers: {
      // 'x-sh-auth': 1234
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const google_signin_admin_api = async (credential) => {
  const requestObj = {
    path: `admin_users/google_signin`,
    method: "POST",
    headers: {},
    postData: { credential },
  };
  return invokeApi(requestObj);
};
